module.exports = __webpack_public_path__ + "img/hangover.6d4a16b9.png";